import { BASE_URL } from "config/config";
import { getSubscriptionId } from "services/auth";
import { client } from "services/axios";
import { getFileNameFromUrl, getFileNameWithoutExtension } from "utils/utils";

export const extractUploadDrawingAPI = async ({
  specificationId,
  signedUrl,
  projectId,
  projectToken
}: {
  specificationId: string;
  signedUrl: string;
  projectId: string;
  projectToken: string;
}) => {
  const fileName = getFileNameFromUrl(signedUrl);
  const fileNameWithoutExt = getFileNameWithoutExtension(fileName || "");
  const res = await client.post(
    `${BASE_URL}/recommender-engine/extract`,
    {
      drawing_id: specificationId,
      file_name: fileNameWithoutExt,
      project_id: projectId,
      subscription_id: getSubscriptionId(),
      signedUrl
    },
    { headers: { Authorization: `Bearer ${projectToken}` } }
  );
  return res;
};

// export const getExtractionStatusAPI = async (specificationId: string) => {
//   const res = await client.get(
//     `${BASE_URL}/recommender-engine/extract/status/${specificationId}`
//   );
//   return res;
// };
